import { render, staticRenderFns } from "./OrderFlowStepProducts.vue?vue&type=template&id=3bd81a34&"
import script from "./OrderFlowStepProducts.vue?vue&type=script&lang=js&"
export * from "./OrderFlowStepProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlowStepProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports